<template>
  <div>
    <form @keydown="form.errors.clear($event.target.name)" @submit.prevent>
      <div class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-sm mb-4">
        <div @click="goBack" class="flex cursor-pointer">
          <span class="material-icons">chevron_left</span>
          <span>Back</span>
        </div>
        <button @click.prevent="saved"
                class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none"
                :disabled="fetching_stages || saving">
          Save
        </button>
      </div>
      <div class="flex justify-between items-start mb-4 flex-wrap flex-lg-nowrap">
        <div class="flex-col w-full lg:w-1/3">
          <div class="rounded bg-white shadow-md mb-4">
            <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
              <span>Job Information</span>
            </div>
            <div class="pt-4 pb-2 px-3">
              <div class="flex items-end">
                <div class="mb-2 leading-tight mr-2 md:w-3/4">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('name')}" for="name">Project
                    Name</label>
                  <input v-model="form.name" type="text" name="name" id="name"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('name')}">
                  <div class="text-red text-xs" v-if="form.errors.has('name')">{{
                      form.errors.get('name')
                    }}
                  </div>
                </div>
              </div>

              <div class="mb-2 leading-tight">
                <label class="text-grey-darkest text-sm"
                       :class="{'text-red' : form.errors.has('address')}" for="address">Address</label>
                <input v-model="form.address" type="text" name="address" id="address"
                       class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                       :class="{'border-red': form.errors.has('address')}">
                <div class="text-red text-xs" v-if="form.errors.has('address')">{{
                    form.errors.get('address')
                  }}
                </div>
              </div>
              <div class="flex">
                <div class="mb-2 leading-tight mr-2 w-1/2">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('city')}" for="city">City</label>
                  <input v-model="form.city" type="text" name="city" id="city"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('city')}">
                  <div class="text-red text-xs" v-if="form.errors.has('city')">{{
                      form.errors.get('city')
                    }}
                  </div>
                </div>
                <div class="mb-2 leading-tight w-1/2">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('state')}" for="state">State</label>
                  <input v-model="form.state" type="text" name="state" id="state"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('state')}">
                  <div class="text-red text-xs" v-if="form.errors.has('state')">{{
                      form.errors.get('state')
                    }}
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="mb-2 leading-tight w-1/2 pr-1">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('zip')}" for="zip">Zip</label>
                  <input v-model="form.zip" type="text" name="zip" id="zip"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('zip')}">
                  <div class="text-red text-xs" v-if="form.errors.has('zip')">{{
                      form.errors.get('zip')
                    }}
                  </div>
                </div>
              </div>
              <div class="mb-2 leading-tight">
                <label class="text-grey-darkest text-sm"
                       :class="{'text-red' : form.errors.has('contact_name')}" for="contact_name">Contact
                  Name</label>
                <input v-model="form.contact_name" type="text" name="contact_name" id="contact_name"
                       class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                       :class="{'border-red': form.errors.has('contact_name')}">
                <div class="text-red text-xs" v-if="form.errors.has('contact_name')">{{
                    form.errors.get('contact_name')
                  }}
                </div>
              </div>
              <div class="mb-2 leading-tight">
                <label class="text-grey-darkest text-sm"
                       :class="{'text-red' : form.errors.has('contact_email')}" for="contact_email">Email</label>
                <div class="flex">
                  <input v-model="form.contact_email" type="text" name="contact_email" id="contact_email"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('contact_email')}">
                  <div class="cursor-pointer text-center ml-3">
                    <a :href="`mailto:${form.contact_email}${mailSubject}`" target="_blank"
                       style="text-decoration: none !important;"
                       class="hover:text-grey-dark material-icons text-3xl">mail</a>
                  </div>
                </div>
                <div class="text-red text-xs" v-if="form.errors.has('contact_email')">{{
                    form.errors.get('contact_email')
                  }}
                </div>
              </div>
              <div class="flex">
                <div class="mb-2 leading-tight mr-2 w-1/2">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('contact_phone')}" for="contact_phone">Phone</label>
                  <input v-model="form.contact_phone" type="text" name="contact_phone"
                         v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                         id="contact_phone"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('contact_phone')}">
                  <div class="text-red text-xs" v-if="form.errors.has('contact_phone')">{{
                      form.errors.get('contact_phone')
                    }}
                  </div>
                </div>
                <div class="mb-2 leading-tight w-1/2">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('contact_cell')}" for="contact_cell">Cell</label>
                  <input v-model="form.contact_cell" type="text" name="contact_cell" id="contact_cell"
                         v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('contact_cell')}">
                  <div class="text-red text-xs" v-if="form.errors.has('contact_cell')">{{
                      form.errors.get('contact_cell')
                    }}
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="mb-2 leading-tight w-1/2 pr-1">
                  <label class="text-grey-darkest text-sm"
                         :class="{'text-red' : form.errors.has('contact_fax')}"
                         for="contact_fax">Fax</label>
                  <input v-model="form.contact_fax" type="text" name="contact_fax" id="contact_fax"
                         v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                         class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                         :class="{'border-red': form.errors.has('contact_fax')}">
                  <div class="text-red text-xs" v-if="form.errors.has('contact_fax')">{{
                      form.errors.get('contact_fax')
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rounded bg-white shadow-md">
            <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
              <span>Cost Record Details</span>
            </div>
            <div class="pt-4 pb-2 px-3">
              <div class="flex flex-wrap">
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label
                      class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                      :class="{'text-red' : form.errors.has('contract_date')}"
                      for="pm_contract_date">Start Date</label>
                  <datepicker
                      format="MM/dd/yyyy"
                      v-model="form.pm_contract_date"
                      :typeable="false"
                      id="pm_contract_date"
                      @keypress.enter.prevent="this.closeCalendar()"
                      wrapper-class="fullscreen-when-on-mobile w-1/2 md:w-2/3"
                      input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                  >
                  </datepicker>
                  <div class="text-red text-xs" v-if="form.errors.has('pm_contract_date')">{{
                      form.errors.get('pm_contract_date')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('contract_amt')}"
                         for="contract_amt">Contract Amount</label>
                  <currency-input
                      id="contract_amt"
                      v-model="form.contract_amt"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('contract_amt')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('contract_amt')">{{
                      form.errors.get('contract_amt')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('change_orders')}"
                         for="change_orders">Changing Orders</label>
                  <currency-input
                      id="change_orders"
                      v-model="form.change_orders"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('change_orders')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('change_orders')">{{
                      form.errors.get('change_orders')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('new_contract_amt')}"
                         for="new_contract_amt">New Contract Amt</label>
                  <currency-input
                      id="new_contract_amt"
                      v-model="form.new_contract_amt"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('new_contract_amt')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('new_contract_amt')">{{
                      form.errors.get('new_contract_amt')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('gross_margin_percentage')}"
                         for="gross_margin_percentage">Est. Gross Margin %</label>
                  <currency-input
                      id="gross_margin_percentage"
                      v-model="form.gross_margin_percentage"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('gross_margin_percentage')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('gross_margin_percentage')">{{
                      form.errors.get('gross_margin_percentage')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('gross_margin_value')}"
                         for="gross_margin_value">Est. Gross Margin $</label>
                  <currency-input
                      id="gross_margin_value"
                      v-model="form.gross_margin_value"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('gross_margin_value')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('gross_margin_value')">{{
                      form.errors.get('gross_margin_value')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('labor_hours')}" for="labor_hours">Est. Labor
                    Hours</label>
                  <input
                      type="number"
                      min="0"
                      v-model="form.labor_hours"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('labor_hours')}"/>
                  <div class="text-red text-xs" v-if="form.errors.has('labor_hours')">{{
                      form.errors.get('labor_hours')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('act_gross_margin_percentage')}"
                         for="act_gross_margin_percentage">Act. Gross Margin %</label>
                  <currency-input
                      id="act_gross_margin_percentage"
                      v-model="form.act_gross_margin_percentage"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('act_gross_margin_percentage')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('act_gross_margin_percentage')">{{
                          form.errors.get('act_gross_margin_percentage')
                      }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('act_gross_margin_value')}"
                         for="act_gross_margin_value">Act. Gross Margin $</label>
                  <currency-input
                      id="act_gross_margin_value"
                      v-model="form.act_gross_margin_value"
                      locale="us"
                      :currency="null"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('act_gross_margin_value')}">
                  </currency-input>
                  <div class="text-red text-xs" v-if="form.errors.has('act_gross_margin_value')">{{
                          form.errors.get('act_gross_margin_value')
                      }}
                  </div>
                </div>
                <div class="mb-2 ml-1 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('act_labor_hours')}"
                         for="act_labor_hours">Act. Labor Hours</label>
                  <input
                      type="number"
                      min="0"
                      v-model="form.act_labor_hours"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      :class="{'border-red': form.errors.has('act_labor_hours')}"/>
                  <div class="text-red text-xs" v-if="form.errors.has('act_labor_hours')">{{
                          form.errors.get('act_labor_hours')
                      }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-col w-full lg:w-1/3 lg:mx-4 mt-4 mt-lg-0">
          <div class="rounded bg-white shadow-md mb-4">
            <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
              <span>Miscellaneous Information</span>
            </div>
            <div class="pt-4 pb-2 px-3">
              <div class="flex flex-wrap">
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">
                    Project Stage
                  </label>
                  <input
                      type="text"
                      class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                      v-bind:value="project_stage_name"
                      disabled
                  >
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('project_duration_id')}"
                         for="project_duration_id">Project Duration</label>
                  <select name="project_duration_id" id="project_duration_id"
                          v-model="form.project_duration_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('project_duration_id')}">
                    <option v-for="item in selects.project_duration" :value="item.id">{{
                        item.full_description
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('project_duration_id')">{{
                      form.errors.get('project_duration_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('complete_date')}">Est. Complete Date</label>
                  <datepicker v-model="form.complete_date" format="MM/dd/yyyy" :typeable="false"
                              @keypress.enter.prevent="this.closeCalendar()"
                              wrapper-class="w-1/2 md:w-2/3 fullscreen-when-on-mobile"
                              input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"></datepicker>
                  <div class="text-red text-xs" v-if="form.errors.has('complete_date')">{{
                      form.errors.get('complete_date')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('actual_completed_date')}">Actual Completed Date</label>
                  <datepicker v-model="form.actual_completed_date" format="MM/dd/yyyy" :typeable="true"
                              @keypress.enter.prevent="this.closeCalendar()"
                              wrapper-class="w-1/2 md:w-2/3 fullscreen-when-on-mobile"
                              input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"></datepicker>
                  <div class="text-red text-xs" v-if="form.errors.has('actual_completed_date')">{{
                      form.errors.get('actual_completed_date')
                    }}
                  </div>
                </div>
                  <div class="mb-2 ml-2 leading-tight w-full row">
                      <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                             :class="{'text-red' : form.errors.has('login_date')}">PM Login Date</label>
                      <input type="text" name="login_date" id="login_date"
                             class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                             :class="{'border-red': form.errors.has('login_date')}" :value="form.login_date" disabled>
                      <div class="text-red text-xs" v-if="form.errors.has('login_date')">{{
                              form.errors.get('login_date')
                          }}
                      </div>
                  </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('project_manager_id')}"
                         for="project_manager_id">Project Manager</label>
                  <select name="project_manager_id" id="project_manager_id"
                          v-model="form.project_manager_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('project_manager_id')}">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{
                        item.name
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('project_manager_id')">{{
                      form.errors.get('project_manager_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('project_engineer_id')}"
                         for="project_engineer_id">Project Engineer</label>
                  <select name="project_engineer_id" id="project_engineer_id"
                          v-model="form.project_engineer_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('project_engineer_id')}">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{
                        item.name
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('project_engineer_id')">{{
                      form.errors.get('project_engineer_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('project_admin_id')}"
                         for="project_admin_id">Project Admin</label>
                  <select name="project_admin_id" id="project_admin_id"
                          v-model="form.project_admin_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('project_admin_id')}">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{
                        item.name
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('project_admin_id')">{{
                      form.errors.get('project_admin_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('superintendent_id')}"
                         for="superintendent_id">Superintendent</label>
                  <select name="superintendent_id" id="superintendent_id"
                          v-model="form.superintendent_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('superintendent_id')}">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{
                        item.name
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('superintendent_id')">{{
                      form.errors.get('superintendent_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('crew_leader_id')}"
                         for="crew_leader_id">Crew Leader</label>
                  <select name="crew_leader_id" id="crew_leader_id"
                          v-model="form.crew_leader_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('crew_leader_id')}">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{
                        item.name
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('crew_leader_id')">{{
                      form.errors.get('crew_leader_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('products_and_services_id')}"
                         for="products_and_services_id">Products & Services</label>
                  <select name="products_and_services_id" id="products_and_services_id"
                          v-model="form.products_and_services_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('products_and_services_id')}">
                    <option selected></option>
                    <option v-for="item in selects.products_and_services" :value="item.id">{{
                        item.full_description
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('products_and_services_id')">{{
                      form.errors.get('products_and_services_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('client_profile_id')}"
                         for="client_profile_id">Client Profile</label>
                  <select name="client_profile_id" id="client_profile_id"
                          v-model="form.client_profile_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('client_profile_id')}">
                    <option selected></option>
                    <option v-for="item in selects.client_profile" :value="item.id">{{
                        item.full_description
                      }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('client_profile_id')">{{
                      form.errors.get('client_profile_id')
                    }}
                  </div>
                </div>
              </div>
              <div class="flex flex-wrap">
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('contract_type_id')}"
                         for="contract_type_id">Contract Type</label>
                  <select name="contract_type_id" id="contract_type_id"
                          v-model="form.contract_type_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('contract_type_id')}">
                    <option selected></option>
                    <option v-for="item in selects.contract_type" :value="item.id">{{ item.full_description }}
                    </option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('contract_type_id')">{{
                      form.errors.get('contract_type_id')
                    }}
                  </div>
                </div>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                         :class="{'text-red' : form.errors.has('office_id')}"
                         for="office_id">Office</label>
                  <select name="office_id" id="office_id"
                          v-model="form.office_id"
                          class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                          :class="{'border-red': form.errors.has('office_id')}">
                    <option selected></option>
                    <option v-for="item in selects.office" :value="item.id">{{ item.full_description }}</option>
                  </select>
                  <div class="text-red text-xs" v-if="form.errors.has('office_id')">{{
                      form.errors.get('office_id')
                    }}
                  </div>
                </div>
              </div>
              <div>
                <project-custom-fields ref="CustomFields" :project="project" :masks="masks" :team="team"></project-custom-fields>
              </div>
            </div>
          </div>
          <div class="rounded bg-white shadow-md">
            <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
              <span>Project Management Behavior Hours</span>
            </div>
            <div class="pt-4 pb-2 px-3">
              <div v-if="behavior_hours_loading">
                Loading...
              </div>
              <div class="flex flex-wrap" v-else>
                <div class="mb-2 ml-2 leading-tight w-full row">
                  <table class="small">
                    <tr class="">
                      <td></td>
                      <td>Estimated</td>
                      <td>Actual</td>
                    </tr>
                    <tr v-for="stage in behavior_hours">
                      <td class="whitespace-no-wrap">{{ stage.project_stage }}</td>
                      <td>
                        <input
                            type="text"
                            class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                            :value="stage.estimated"
                            disabled
                        >
                      </td>
                      <td>
                        <input v-if="stage.actual !== null"
                               type="text"
                               class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                               :value="stage.actual"
                               disabled
                        >
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rounded bg-white shadow-md lg:w-1/3 mt-4 mt-lg-0 hidden lg:inline">
          <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
            <span>Project Management Behaviors</span>
          </div>

          <div class="pt-4 pb-2 px-3">
            <div class="accordion" id="accordionManagementBehaviors">
              <div class="card" style="overflow: inherit" v-if="form.pm_behaviors.length > 0"
                   v-for="(item, index) in form.pm_behaviors" :key="index">
                <div class="card-header" v-bind:id="'heading' + index">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                            v-bind:data-target="'#collapse' + index" aria-expanded="true"
                            v-bind:aria-controls="'collapse' + index">
                      {{ item.full_description }}
                    </button>
                  </h2>
                </div>
                <div
                    v-bind:id="'collapse' + index"
                    class="collapse"
                    v-bind:class="{show: index === 0}"
                    v-bind:aria-labelledby="'heading' + index"
                    data-parent="#accordionManagementBehaviors"
                >
                  <div class="card-body">
                    <ul class="list-group">
                      <li class="list-group-item"
                          v-for="(constructionBehavior, idx) in item.project_management_behaviors">

                        <div class="form-group form-check pl-0 mb-1">
                          <input type="checkbox" v-model="constructionBehavior.completed">
                          <label class="form-check-label">{{ constructionBehavior.name }}</label>
                            <div class="float-right">
                                <i v-if="constructionBehavior.unlock_activity === 1" class="fa fa-unlock-alt" style="color: #14b1af;" aria-hidden="true"></i>
                                <i v-else class="fa fa-lock" style="color: #f35959;" aria-hidden="true"></i>
                                <span style="color: rgb(209 209 212);font-size: 14px;">N/A</span>
                            </div>

                        </div>
                        <div class="row">
                          <div class="col-md-6 d-flex align-items-center">
                            <datepicker v-model="constructionBehavior.date"
                                        :ref=constructionBehavior.name
                                        format="MM/dd/yyyy"
                                        :typeable="false"
                                        @keypress.enter.prevent="this.closeCalendar()"
                                        @input="changeBehaviorDate(constructionBehavior.date = fixDate($event),constructionBehavior.project_stage_id,constructionBehavior.load_order,index)"
                                        :wrapper-class="atLeastOneHasDate ? 'w-5/6 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile '"
                                        input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1">
                            </datepicker>
                            <button  type="button"
                                     @click="clearBehaviorDate(index, idx)"
                               v-if="constructionBehavior.date && (constructionBehavior.completed === undefined || ((constructionBehavior.completed === 0 && constructionBehavior.unlock_activity === 0) || (constructionBehavior.completed === 1 && constructionBehavior.unlock_activity === 1)))"
                               class="material-icons text-grey-darkest text-xl focus:outline-none ml-1">clear
                            </button>
                          </div>
                          <div class="col-md-6">
                            <select
                                name="assigned_to"
                                v-model="constructionBehavior.user_id"
                                class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-100"
                            >
                              <option></option>
                              <option v-for="user in selects.users" :value="user.id">
                                {{ user.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="fetching_stages" class="mb-2">
                Loading
              </div>
              <div v-if="!fetching_stages && form.pm_behaviors.length === 0" class="mb-2">
                <div class="text-grey-darkest text-sm">
                  Your company does not currently have any project management behaviors.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rounded bg-white shadow-md mb-4">
        <external-email-section :project="project" :email="form.contact_email" :exchange="exchange" :canEdit="canEdit" :allContacts="[]"
                                @refresh-comments="fetchComments()"></external-email-section>
      </div>
      <div class="rounded bg-white shadow-md mb-4">
        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
          <span>Client Information</span>
        </div>
        <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch">
          <div class="flex-col w-full lg:w-1/3 pr-4">
            <div class="mb-1 text-grey-darkest text-sm">Text</div>
            <div class="mb-4 leading-tight">
              <label class="text-grey-darkest text-sm" for="companies">Client</label>
            </div>
          </div>
          <div class="hidden lg:flex border-1 border-grey mr-4"></div>
          <div class="flex-1">
          </div>
        </div>
      </div>

      <project-comments ref="projectcomments" :project="project" :isAdmin="isAdmin" :canEdit="canEdit" :user="spark.state.user" :isPM="true" ></project-comments>

    </form>
    <external-email-file-modal ref="EmailFileModal"></external-email-file-modal>
    <company-create-modal ref="CompanyCreateModal" @inserted="fetchCompanies"></company-create-modal>
  </div>
</template>

<script>

import Form            from "../../utils/form";
import Datepicker      from 'vuejs-datepicker';
import {CurrencyInput} from 'vue-currency-input';

export default {
  name : 'project-management-create',
  props: ['company', 'project', 'reference','masks','isAdmin', 'canEdit', 'exchange', 'team'],

  components: {Datepicker, CurrencyInput},

  data() {
    return {
      behavior_hours_loading: true,
      behavior_hours        : [],
      fetching_stages       : true,
      allCompanies          : [],
      contacts              : [],
      users                 : [],
      selectedCompany       : null,
      options               : {
        format    : 'MM/dd/yyyy',
        useCurrent: false,
      },
      project_comments      : this.project.comments,
      selects               : {},
      form                  : new Form({
        project_id              : this.project.id,
        company_contacts        : this.project.company_contacts,
        name                    : this.project.name,
        bid_bond                : this.project.bid_bond || false,
        address                 : this.project.address,
        city                    : this.project.city,
        state                   : this.project.state,
        zip                     : this.project.zip,
        contact_name            : this.project.contact ? this.project.contact.name : '',
        contact_email           : this.project.contact ? this.project.contact.email : '',
        contact_phone           : this.project.contact && this.project.contact.phone ? this.project.contact.phone.replace(/\D/g, '') : '',
        contact_cell            : this.project.contact && this.project.contact.cell ? this.project.contact.cell.replace(/\D/g, '') : '',
        contact_fax             : this.project.contact && this.project.contact.fax ? this.project.contact.fax.replace(/\D/g, '') : '',
        contract_amt            : this.project.contract_amount ? Number(this.project.contract_amount.split(',').join('')) : null,
        pm_contract_date        : this.project.contract_date ? moment(this.project.contract_date).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
        gross_margin_percentage : this.project.gross_margin_percentage ? Number(this.project.gross_margin_percentage.split(',').join('')) : null,
        gross_margin_value      : this.project.gross_margin_value ? Number(this.project.gross_margin_value.split(',').join('')) : null,
        labor_hours             : this.project.labor_hours,
        project_stage_id        : this.project.project_stage_id,
        project_duration_id     : this.project.project_duration_id,
        complete_date           : this.project.complete_date,
        change_orders           : this.project.change_orders,
        new_contract_amt        : this.project.new_contract_amt,
        actual_completed_date   : this.project.actual_completed_date,
        project_manager_id      : this.project.project_manager_id,
        project_engineer_id     : this.project.project_engineer_id,
        project_admin_id        : this.project.project_admin_id,
        superintendent_id       : this.project.superintendent_id,
        crew_leader_id          : this.project.crew_leader_id,
        pre_construction_est    : this.project.pre_construction_est,
        production_est          : this.project.production_est,
        close_out_est           : this.project.close_out_est,
        total_hours_remaining   : this.project.total_hours_remaining,
        pm_status_id            : this.project.pm_status,
        marketing_status_id     : this.project.marketing_status,
        pre_bid                 : this.project.pre_bid,
        bid_date                : this.project.bid_date,
        created_at              : this.project.created_at,
        dead_date               : this.project.dead_date,
        lead_from_id            : this.project.lead_from,
        products_and_services_id: this.project.products_and_services,
        client_profile_id       : this.project.client_profile,
        contract_type_id        : this.project.contract_type,
        office_id               : this.project.office,
        pm_behaviors            : [],
        login_date              : moment().format('MM/DD/YYYY'),
        act_gross_margin_percentage : null,
        act_gross_margin_value      : null,
        act_labor_hours             : null,
      }),
      project_stage_name    : null,
      editing               : false,
      current_comment       : null,
      company_contact       : null,
      pm_status             : null,
      projectCommentForm    : new Form({
        id                : null,
        comment           : '',
        date              : '',
        company_contact_id: null,
        pm_status_id      : null,
        mentioned_users   : []
      }),
      loading_pm_behaviors  : true,
      saving                : false,
      existPmBehaviors      : false,
    }
  },

  created() {
    this.fetchCompanies();
    this.fetchCodes();
    this.fetchDurations();
    this.fetchStages();
    this.fetchBehaviorHours();
    if (this.reference) this.parseReference();
  },

  computed: {
    atLeastOneHasDate() {
      return _.some(this.form.pm_behaviors, (item) => item.date && item.assigned_to);
    },
    mailSubject() {
      return `?subject=(${this.project.id} - ${this.project.name})`;
    },
  },

  watch: {
    'form.project_engineer_id': function (value) {
      this.changeUserBehavior(value, 'project_engineer_id');
    },
    'form.project_manager_id' : function (value) {
      this.changeUserBehavior(value, 'project_manager_id');
    },
    'form.project_admin_id'   : function (value) {
      this.changeUserBehavior(value, 'project_admin_id');
    },
    'form.superintendent_id'  : function (value) {
      this.changeUserBehavior(value, 'superintendent_id');
    },
    'form.crew_leader_id'     : function (value) {
      this.changeUserBehavior(value, 'crew_leader_id');
    },
      'form.contract_type_id'   : function () {
          this.fetchStagesByContractType();
      },
    'form.project_duration_id': function (value) {
      this.updateStepDate(this.form.pm_contract_date);
    },
    'form.pm_contract_date'   : function (value) {
      this.updateStepDate(value);
    },
  },

  methods: {

    pmContractDateSelect(date) {

      this.form.pm_contract_date = moment(date).format('YYYY-MM-DD');
    },

    fetchCompanies(newCompany = null) {
      axios.get(route('api.project.companies')).then(({data}) => {
        this.allCompanies = data.data;

        if (newCompany) this.handleNewCompany(newCompany);
      })
    },

    fetchContacts() {
      if (this.selectedCompany) {
        axios.get(route('api.company.contacts', {company: this.selectedCompany.id})).then(({data}) => {
          this.contacts = data.data;
        });
      } else {
        this.contacts = [];
      }
    },

    fetchCodes() {
      axios.get(route('api.project.codes')).then(({data}) => {
        this.selects = {...this.selects, ...data};
        if (this.reference) {
          let ss = _.find(data.pm_status, {code: 'Pending'});
          if (ss) this.form.pm_contract_date = ss.id;
        }
      });
    },

    fetchComments() {
      // axios.get(route('api.project-comment.index', {project: this.project.id})).then(({data}) => {
      //   this.project_comments = data.data;
      // });
    },

    /**
     * Fetches the projects durations
     */
    fetchDurations() {

      axios.get(route('project-management.api.settings.codes.project-duration.index'))
          .then(({data}) => {
            this.form.project_duration_id = data[0].id;
            this.selects                  = {...this.selects, 'project_duration': data};

          });
    },

      fetchStagesByContractType() {
          let self                = this;
          this.fetching_stages    = true;
          this.pmBehaviorsExistInContractType(self.form.contract_type_id);

          axios.get(route('project-management.api.settings.codes.project-stage.index'))
              .then(({data}) => {
                  let tempPmBehaviors = data;

                  tempPmBehaviors.forEach(function (stage) {
                      stage.project_management_behaviors = _.filter(stage.project_management_behaviors, {contract_type_id: (self.existPmBehaviors ? self.form.contract_type_id : null)});
                  });

                  tempPmBehaviors.forEach(function (stage) {
                      stage.project_management_behaviors.forEach(function (behavior) {
                          let selectedBehavior = _.filter(self.project.project_behaviors, {id: behavior.id});
                          if (selectedBehavior.length > 0) {
                              behavior.user_id           = selectedBehavior[0].pivot.user_id;
                              behavior.completed         = selectedBehavior[0].pivot.completed;
                              behavior.already_completed = selectedBehavior[0].pivot.completed;
                              behavior.date              = moment(selectedBehavior[0].pivot.date).utc(1).format('MM/DD/YYYY');
                          } else {
                              behavior.user_id = null;
                              behavior.date    = null;
                          }
                      });
                  });

                  this.form.pm_behaviors = tempPmBehaviors;
                  this.fetching_stages   = false;
                  this.updateStepDate(this.form.pm_contract_date)
              });
      },

    pmBehaviorsExistInContractType(contractTypeId) {
        if(contractTypeId) {
          axios.get(route('project-management.api.settings.project-management-behavior.verify-exist-by-contract-type_id', [contractTypeId]))
              .then(({data}) => {
                this.existPmBehaviors = data > 0;
              });
        }
    },

    fetchStages() {
      let self             = this;
      this.fetching_stages = true;
      this.pmBehaviorsExistInContractType(self.form.contract_type_id);

      axios.get(route('project-management.api.settings.codes.project-stage.index'))
          .then(({data}) => {
            let tempPmBehaviors = data;

            tempPmBehaviors.forEach(function (stage) {
              stage.project_management_behaviors = _.filter(stage.project_management_behaviors, {contract_type_id: (self.existPmBehaviors ? self.form.contract_type_id : null)});
            });

            this.form.pm_behaviors  = tempPmBehaviors;
            this.selects            = {...this.selects, 'project_stages': tempPmBehaviors};
            this.project_stage_name = data[0].short_description;
            this.fetching_stages    = false;
            this.updateStepDate(this.form.pm_contract_date);
          });
    },

    async fetchBehaviorHours() {
      this.behavior_hours_loading = true;
      let {data}                  = await axios.get(route('project-management.api.project.behavior-hours', {project: this.project.id}));
      this.behavior_hours         = data;
      this.behavior_hours_loading = false;
    },

    saved() {
      this.saving = true;
      let self    = this;
      this.form.post(route('api.project-management.store')).then((data) => {
        this.saving = false;
        if (data.status != 'error') {
          this.$refs.CustomFields.submit(data.project_id);
          Swal.fire({
            title             : 'Created',
            text              : "Your project management has been created.",
            type              : 'success',
            showCancelButton  : false,
            confirmButtonColor: '#17252A',
            confirmButtonText : 'OK!',
            closeOnConfirm    : false,
          }).then(() => {
            window.location = self.company ? route('company.show', {company: self.company.id}) : route('project-management.project.edit', {projectManagement: data.project_id});
          });
        } else {
          Swal.fire({
            title             : 'Error',
            text              : data.message,
            type              : data.status,
            showCancelButton  : false,
            confirmButtonColor: '#17252A',
            confirmButtonText : 'OK!',
            closeOnConfirm    : false,
          });
        }
      });
    },

    goBack() {
      window.location = this.company ? route('company.show', {company: this.company.id}) : route('project-management.project.index');
    },

    removeDate(item) {
      this.$refs[item][0].clearDate();
    },

    addContact(contact) {
      this.form.company_contacts.push(contact);
    },

    removeContact(contact) {
      this.form.company_contacts = this.form.company_contacts.filter(function (addedContact) {
        return addedContact.id !== contact.id;
      });
    },

    addOrRemoveContact(contact) {
      this.contactAddedAlready(contact) ? this.removeContact(contact) : this.addContact(contact);
    },

    contactAddedAlready(contact) {
      return this.form.company_contacts.filter(x => contact.id === x.id).length > 0;
    },

    parseReference() {
      for (let key in this.form) {
        if (
            [
              'pm_behaviors',
              'base_bid',
              'contract_amt',
              'contract_date',
              'new_contract_amt',
              'gross_margin_percentage',
              'gross_margin_value',
              'labor_hours',
              'pm_contract_date',
              'complete_date',
              'actual_completed_date'
            ].indexOf(key) === -1
        ) {
          if (this.reference.hasOwnProperty(key)) {
            this.form[key] = this.reference[key];
          }

          if (key.indexOf('contact') !== -1 && key !== 'company_contacts') {
            this.form[key] = this.reference.contact[key.slice(8)];
          }

          if (key.indexOf('_id') !== -1) {
            this.form[key] = this.reference[key.slice(0, -3)];
          }
        }
      }
    },

    checkProposalDelivered(pmBehavior) {
      if (pmBehavior.proposal_delivered === 1 && pmBehavior.completed == 1 && !this.form.complete_date) {
        this.form.complete_date = pmBehavior.date;
      }
    },

    openCompanyCreateModal(name) {
      this.$refs.CompanyCreateModal.open(name);
    },

    async handleNewCompany(company) {
      this.selectedCompany = _.find(this.allCompanies, {id: company.id});
      this.fetchContacts();
    },

    changeUserBehavior(userId, assignedTo) {
      this.form.pm_behaviors.forEach(function (stage) {
        stage.project_management_behaviors.forEach(function (behavior) {
          if (behavior.assigned_to == assignedTo) {
            behavior.user_id = userId;
          }
        });
      });
    },

      changeBehaviorDate(date, stageId, loadOrder, stageIndexInput){
          const self = this;

          let lastDate = moment(date);
          let difference = 0;
          let allBehaviors = [];

          let previousDuration = 0;
          self.form.pm_behaviors = _.map(self.form.pm_behaviors, (stage, stageIndex) => {
              allBehaviors = _.concat(allBehaviors, stage.project_management_behaviors);
              if(stageIndex >= stageIndexInput) {

                  stage.project_management_behaviors = _.map(stage.project_management_behaviors, (behavior) => {

                      const duration = (self.form.project_duration_id) ? _.find(behavior.project_durations, x => x.id === self.form.project_duration_id) : null;

                      if(duration && date) {
                          difference = duration.pivot.days - previousDuration;

                          // if next stage or same stage with load order greater then current behavior modified
                          if ((stageId !== stage.id) || (stageId === stage.id && behavior.load_order > loadOrder)){
                              if (((behavior.already_completed === 1 && behavior.unlock_activity === 0) || behavior.not_available === 1) || !behavior.date) {
                                  lastDate = moment(lastDate).add(difference, 'days');
                              }else{
                                  lastDate = moment(lastDate).add(difference, 'days');
                                  behavior.date = lastDate.isValid() ? lastDate.utc(1).format('MM/DD/YYYY') : null;
                              }
                          }
                          previousDuration = duration.pivot.days;
                      }
                      return behavior;
                  })
              }
              return stage;
          })

          allBehaviors = _.filter(allBehaviors, x => x.date !== null)
          if(allBehaviors.length > 0) {
              self.form.complete_date = moment(_.last(allBehaviors).date).utc(1).format('MM/DD/YYYY') ;
          }else{
              self.form.complete_date = moment(self.form.pm_contract_date).utc(1).format('MM/DD/YYYY') ;
          }
      },

    updateStepDate(pmContractDate) {
        const self = this;

        let lastDate = moment(pmContractDate);
        let difference = 0;
        let allBehaviors = [];

        if(self.form.pm_behaviors.length > 0) {

            let previousDuration = 0;
            self.form.pm_behaviors = _.map(self.form.pm_behaviors, (stage) => {
                allBehaviors = _.concat(allBehaviors, stage.project_management_behaviors);

                stage.project_management_behaviors = _.map(stage.project_management_behaviors, (behavior) => {

                    const duration = (self.form.project_duration_id) ? _.find(behavior.project_durations, x => x.id === self.form.project_duration_id) : null;

                    if(duration) {
                        difference = duration.pivot.days - previousDuration;

                        lastDate = moment(lastDate).add(difference, 'days');
                        behavior.date = lastDate.isValid() ? lastDate.utc(1).format('MM/DD/YYYY') : null;
                        previousDuration = duration.pivot.days
                    }
                    return behavior;
                })

                return stage;
            })

            allBehaviors = _.filter(allBehaviors, x => x.date !== null)
            if(allBehaviors.length > 0) {
                self.form.complete_date = moment(_.last(allBehaviors).date).utc(1).format('MM/DD/YYYY') ;
            }else{
                self.form.complete_date = moment(self.form.pm_contract_date).utc(1).format('MM/DD/YYYY') ;
            }
        }
    },

      clearBehaviorDate(stageIndex, behaviorIndex) {
          const self = this;
          let allBehaviors = [];
          if(self.form.pm_behaviors.length > 0) {
              self.form.pm_behaviors = _.map(self.form.pm_behaviors, (stage, sIndex) => {
                  allBehaviors = _.concat(allBehaviors, stage.project_management_behaviors);
                  stage.project_management_behaviors = _.map(stage.project_management_behaviors, (behavior, bIndex) => {

                      if(sIndex === stageIndex && bIndex === behaviorIndex) {
                        behavior.date = null;
                      }
                      return behavior;
                  })
                  return stage;
              })
              allBehaviors = _.filter(allBehaviors, x => x.date !== null)
              if(allBehaviors.length > 0) {
                  self.form.complete_date = moment(_.last(allBehaviors).date).utc(1).format('MM/DD/YYYY') ;
              }else{
                  self.form.complete_date = moment(self.form.pm_contract_date).utc(1).format('MM/DD/YYYY') ;
              }

          }
      },
      fixDate(event){
          return moment(event).format('MM/DD/yyyy');
      },
  }
}
</script>

<style lang="scss">
.vdp-datepicker {
  &.fullscreen-when-on-mobile {
    @media (max-width: 767px) {
      position: static;
      .vdp-datepicker__calendar {
        position: fixed;
        top: 50%;
        left: 5%;
        margin-top: -25%;
        width: 90%;
        z-index: 2000;
        outline: rgba(0, 0, 0, 0.5) solid 9999px;
      }
    }
  }
}

.pm-behavior-checkbox {
  width: 1.3rem;
  height: 1.3rem;
}

.cell {
  &.today {
    background-color: rgb(220, 245, 252);
  }
}
</style>
